// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { LoadWeigherStatus } from './load-weigher-status';


export class LoadWeigherStatusMessage implements flatbuffers.IUnpackableObject<LoadWeigherStatusMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):LoadWeigherStatusMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsLoadWeigherStatusMessage(bb:flatbuffers.ByteBuffer, obj?:LoadWeigherStatusMessage):LoadWeigherStatusMessage {
  return (obj || new LoadWeigherStatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsLoadWeigherStatusMessage(bb:flatbuffers.ByteBuffer, obj?:LoadWeigherStatusMessage):LoadWeigherStatusMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new LoadWeigherStatusMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

message():LoadWeigherStatus {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : LoadWeigherStatus.Light;
}

static startLoadWeigherStatusMessage(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addMessage(builder:flatbuffers.Builder, message:LoadWeigherStatus) {
  builder.addFieldInt16(0, message, LoadWeigherStatus.Light);
}

static endLoadWeigherStatusMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createLoadWeigherStatusMessage(builder:flatbuffers.Builder, message:LoadWeigherStatus):flatbuffers.Offset {
  LoadWeigherStatusMessage.startLoadWeigherStatusMessage(builder);
  LoadWeigherStatusMessage.addMessage(builder, message);
  return LoadWeigherStatusMessage.endLoadWeigherStatusMessage(builder);
}

unpack(): LoadWeigherStatusMessageT {
  return new LoadWeigherStatusMessageT(
    this.message()
  );
}


unpackTo(_o: LoadWeigherStatusMessageT): void {
  _o.message = this.message();
}



unpackFields(...fields: string[]): LoadWeigherStatusMessageT {
  const t = new LoadWeigherStatusMessageT();
  const fieldSet = new Set(fields);
  if (fieldSet.has('message')) {
    t.message = this.message();
  }
  return t;
}
}

export class LoadWeigherStatusMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public message: LoadWeigherStatus = LoadWeigherStatus.Light
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return LoadWeigherStatusMessage.createLoadWeigherStatusMessage(builder,
    this.message
  );
}

clone(): LoadWeigherStatusMessageT {
  const obj = new LoadWeigherStatusMessageT();
  obj.message = this.message;
  return obj;
}

equals(other: LoadWeigherStatusMessageT): boolean {
  if (this.message !== other.message) return false;
  return true;
}
}

export function verifyLoadWeigherStatusMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
  } finally {
    verifier.popDepth();
  }
}
